import { signoutUser } from '@/composables/auth';
import { getUserData } from '@/composables/user';
import { i18nGlobal } from '@/i18n';
import { useStoreAuth } from '@/stores/storeAuth';
import { useStoreUser } from '@/stores/storeUser';
import loggerLocal from '@/utils/loggerLocal';
import { showErrorMessage } from '@/utils/showMessage';
import { ref } from 'vue';

const initialized = ref( false ); // evita richieste duplicate

export function useUserSession () {
    const loading = ref( false );
    const storeAuth = useStoreAuth();
    const storeUser = useStoreUser();

    const init = async (): Promise<boolean> => {
        if ( initialized.value || storeUser.userData?.id )
        {
            loggerLocal.info( 'User session already initialized' );
            return true;
        }

        if ( storeUser.fetching )
        {
            loggerLocal.info( 'User session already fetching...' );
            return false;
        }

        loading.value = true;

        try
        {
            const res = await getUserData();

            if ( !res || res.isRegistered === false )
            {
                loggerLocal.error( 'Utente non registrato' );
                showErrorMessage(
                    `${ i18nGlobal.t( 'error.initUserDataError' ) } useUserSession`,
                    res
                );
                await signoutUser();
                return false;
            } else
            {
                loggerLocal.info( 'User data successfully fetched' );
            }

            initialized.value = true;
            return true;
        } catch ( err )
        {
            loggerLocal.error( 'Errore in useUserSession', err );
            return false;
        } finally
        {
            loading.value = false;
        }
    };

    return {
        loading,
        initialized,
        init,
    };
}
